// ----------------------------------------------------------------------
// <copyright file="Izenda.SystemModeSettingActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------
!(function() {
  var m = require('mobx');
  var compose = require('recompose').compose;
  var withHandlers = require('recompose').withHandlers;
  var settingConstant = require('logic/data/Izenda.SettingConstants');
  const { curry } = require('lodash/fp');

  var SystemModeSettingActions = compose(
    withHandlers({
      swithToSingleTenant: curry(swithToSingleTenant),
      switchToMultiTenant: curry(switchToMultiTenant),
      changeAllowDuplicate: curry(changeAllowDuplicate)
    })
  );

  /**
   * Switch to Single Tenant mode
   * @param {type} props
   * @param {type} _
   */
  function swithToSingleTenant(props, _) {
    var systemModeSetting = props.store.systemModeSetting;

    return props
      .confirmFn('Confirmation', {
        description: props.localization.getText('LICENSE_CHECKER_MESSAGE_CONFIRM_MULTI_TO_SINGLE')
      })
      .then(function() {
        var saveData = m.toJS(systemModeSetting);
        saveData.systemMode = settingConstant.SYSTEM_MODE;
        return props.store.saveSystemSetting(saveData);
      })
      .then(function(result) {
        var errorMessages = result.messages;
        if (!result.success) {
          props.confirmMessage('error', errorMessages[0].messages[0]);
        } else {
          systemModeSetting.switchToSingle();
        }
        return null;
      });
  }

  /**
   * Switch to Multiple Tenant mode
   * @param {type} props
   * @param {type} _
   */
  function switchToMultiTenant(props, _) {
    var systemModeSetting = props.store.systemModeSetting;

    return props
      .confirmFn('Confirmation', {
        description: props.localization.getText('LICENSE_CHECKER_MESSAGE_CONFIRM_SINGLE_TO_MULTI')
      })
      .then(function() {
        var saveData = m.toJS(systemModeSetting);
        saveData.systemMode = settingConstant.TENANT_MODE;
        saveData.allowDuplicateUser = true;
        return props.store.saveSystemSetting(saveData);
      })
      .then(function(result) {
        var errorMessages = result.messages;
        if (!result.success) {
          props.confirmMessage('error', errorMessages[0].messages[0]);
        } else {
          systemModeSetting.switchToMulti();
        }
        return null;
      });
  }

  /**
   * Change allow duplicate user
   * @param {type} props
   * @param {type} _
   */
  function changeAllowDuplicate(props, e) {
    var newValue = e.target.checked;
    var systemModeSetting = props.store.systemModeSetting;
    var saveData = m.toJS(systemModeSetting);
    saveData.allowDuplicateUser = newValue;

    return props.store.saveSystemSetting(saveData).then(function(result) {
      var errorMessages = result.messages;
      if (!result.success) {
        props.confirmMessage('error', errorMessages[0].messages[0]);
      } else {
        systemModeSetting.updateAllowDuplicateUser(newValue);
      }
      return null;
    });
  }

  module.exports = SystemModeSettingActions;
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/LicenseChecker/Izenda.SystemModeSettingActions.js